import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EngineLtvService, LifeTimeValueDTO } from '../../../../services/engine-ltv.service';

@Component({
  selector: 'dmp-dyn-raw-detail-ltv',
  templateUrl: './dyn-raw-detail-ltv.component.html',
  styleUrls: ['./dyn-raw-detail-ltv.component.scss'],
  standalone: false
})
export class DynRawDetailLtvComponent implements OnInit {

  @Input() tenant: string;
  @Input() partner: string;
  @Input() isPersonalDataview: boolean = false;
  @Input() isCommandDataview: boolean = false;
  /** personalId for contact fiche, commandId for command fiche */
  @Input() mainId: number;

  ltv: LifeTimeValueDTO | null = null;
  loading = false;

  constructor(
    private ltvService: EngineLtvService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    if (!this.tenant || !this.mainId) {
      return;
    }
    this.loadLtv();
  }

  loadLtv(): void {
    this.loading = true;

    const observable = this.isPersonalDataview
      ? this.ltvService.getForPersonal(this.tenant, this.mainId, this.partner)
      : this.ltvService.getForCommand(this.tenant, this.mainId, this.partner);

    observable.subscribe({
      next: ltv => {
        this.ltv = ltv;
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('view.details.ltv.error.summary'),
          detail: this.translate.instant('view.details.ltv.error.detail', { message: err.message })
        });
      }
    });
  }

  formatCurrency(value: number | null): string {
    if (value === null || value === undefined) {
      return '—';
    }
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value);
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '—';
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    }).format(new Date(dateStr));
  }

  getFluxLabel(flux: string | undefined): string {
    if (!flux) {
      return '—';
    }
    if (flux === 'IMPORT') {
      return this.translate.instant('view.details.campaigns.fluxImport');
    }
    if (flux === 'EXPORT_DIRECT' || flux === 'EXPORT_SCENARIO') {
      return this.translate.instant('view.details.campaigns.fluxExport');
    }
    return flux;
  }

  getCostTypeLabel(costType: string | undefined): string {
    if (costType === 'SALE') {
      return this.translate.instant('view.details.ltv.records.sale');
    }
    if (costType === 'ACQUISITION') {
      return this.translate.instant('view.details.ltv.records.acquisition');
    }
    return costType || '—';
  }
}
